import React, {memo} from 'react';
import {Button, ExpandBoxIcon} from '@taopix/taopix-design-system';
import {useTranslation} from 'react-i18next';

export type PrivacyPolicyButtonProps = {
  privacyPolicyUrl: string;
};

const PrivacyPolicyButton = ({privacyPolicyUrl}: PrivacyPolicyButtonProps) => {
  const {t} = useTranslation(['assetservices']);

  if (!privacyPolicyUrl) return <></>;

  return (
    <Button
      buttonStyle="link"
      label={t('str_ButtonPrivacyPolicy')}
      endIcon={<ExpandBoxIcon />}
      iconColourOverride="themeAccentColour"
      size={'small'}
      onClick={() => window.open(privacyPolicyUrl, '_blank')}
      className={'mt-lg'}
    />
  );
};

export default memo(PrivacyPolicyButton);
